import React, { useEffect, useRef } from 'react';
import DecorSvg1, { DecorSvg2, DecorSvg3, DecorSvg4, DecorSvg5, DecorSvg6, DecorSvg7, DecorSvg8 } from '../../assets/Svg/DecorSvg';

const DecorativeBackground: React.FC = () => {
  const layersRef = useRef<(HTMLDivElement | null)[]>([]);
  const requestRef = useRef<number | null>(null);
  const mouseRef = useRef({ x: 0, y: 0 });
  const smoothMouseRef = useRef({ x: 0, y: 0 });

  const layers = [
    { Component: DecorSvg1, speed: 0.08, id: "0df7043", width: "364", height: "416", imgClass: "wp-image-17767" },
    { Component: DecorSvg3, speed: 0.06, id: "edca655", width: "398", height: "398", imgClass: "wp-image-17779" },
    { Component: DecorSvg4, speed: 0.10, id: "0eda9d4", width: "169", height: "170", imgClass: "wp-image-17780" },
    { Component: DecorSvg5, speed: 0.25, id: "e0809a4", width: "59", height: "59", imgClass: "wp-image-17794" },
    { Component: DecorSvg6, speed: 0.20, id: "b4f90fd", width: "81", height: "72", imgClass: "wp-image-17795" },
    { Component: DecorSvg7, speed: 0.35, id: "04f1cc1", width: "46", height: "53", imgClass: "wp-image-17796" },
    { Component: DecorSvg8, speed: 0.45, id: "ad4b568", width: "28", height: "28", imgClass: "wp-image-17793" },
    { Component: DecorSvg2, speed: 0.15, id: "5d56f69", width: "214", height: "237", imgClass: "wp-image-17768" },
  ];

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      mouseRef.current = {
        x: e.clientX - window.innerWidth / 2,
        y: e.clientY - window.innerHeight / 2
      };
    };

    window.addEventListener('mousemove', handleMouseMove);

    const animate = () => {
      const smoothing = 0.2;
      smoothMouseRef.current.x += (mouseRef.current.x - smoothMouseRef.current.x) * smoothing;
      smoothMouseRef.current.y += (mouseRef.current.y - smoothMouseRef.current.y) * smoothing;

      layersRef.current.forEach((layer, index) => {
        if (layer) {
          const speed = layers[index].speed;
          const x = smoothMouseRef.current.x * speed;
          const y = smoothMouseRef.current.y * speed;

          layer.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        }
      });

      requestRef.current = requestAnimationFrame(animate);
    };

    requestRef.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (requestRef.current !== null) {
        cancelAnimationFrame(requestRef.current);
      }
    };
  });

  return (
    <div className="custom_bg_layout_area" style={{ overflow: 'hidden' }}>
      <style>{`
        @media (max-width: 767px) {
          .wp-image-17767 { display: none !important; } /* Decor1 */
          .wp-image-17768 { display: none !important; } /* Decor2 */
          .wp-image-17779 { display: none !important; } /* Decor3 */
          .wp-image-17780 { display: none !important; } /* Decor4 */
        }
      `}</style>
      <div className="elementor elementor-17754">
        <section className="elementor-section elementor-top-section elementor-element elementor-element-e39f28c elementor-section-full_width elementor-section-height-full elementor-section-items-top elementor-section-height-default" data-id="e39f28c" data-element_type="section">
          <div className="elementor-container elementor-column-gap-extended">
            <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4839232 sc_content_align_inherit sc_layouts_column_icons_position_left" data-id="4839232" data-element_type="column">
              <div className="elementor-widget-wrap elementor-element-populated">
                {layers.map((item, index) => (
                  <div
                    key={item.id}
                    ref={(el) => { layersRef.current[index] = el; }}
                    className={`sc_layouts_item elementor-element elementor-element-${item.id} elementor-widget__width-auto elementor-absolute elementor-widget-tablet__width-initial elementor-widget elementor-widget-image`}
                    data-id={item.id}
                    data-element_type="widget"
                    data-settings='{"_position":"absolute"}'
                    data-widget_type="image.default"
                    style={{ position: 'absolute', willChange: 'transform' }}
                  >
                    <div className="elementor-widget-container">
                      <item.Component
                        width={item.width}
                        height={item.height}
                        className={`attachment-full size-full ${item.imgClass}`}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default DecorativeBackground;
